import { render, staticRenderFns } from "./MDA.vue?vue&type=template&id=229a512a&scoped=true&"
import script from "./MDA.vue?vue&type=script&lang=js&"
export * from "./MDA.vue?vue&type=script&lang=js&"
import style0 from "./MDA.vue?vue&type=style&index=0&id=229a512a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229a512a",
  null
  
)

export default component.exports